module.exports = __webpack_public_path__ + "static/img/30海南华章.18c45d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/30海南华章.jpg
// module id = 9Q5R
// module chunks = 1